import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async updateGift({ commit, rootGetters: { getOrder } }, { gift }) {
    try {
      const { data } = await request.patch(
        `/orders/${getOrder.uuid}/gift`,
        gift,
      );

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      await commit('updateOrderGift', { gift });
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
